import { TReduxActions } from '../../types/redux';
import { EActionTypes } from '../../actions/checkEstimationExists';

import { ICheckEstimationExists } from '../../types/redux/checkEstimationExists';

export const defaultState: ICheckEstimationExists = {
  isFetching: false,
  isNotFound: false,
};

export const checkEstimationExistsReducer = (state = defaultState, action: TReduxActions): ICheckEstimationExists => {
  switch (action.type) {
    case EActionTypes.CHECK_ESTIMATION_EXISTS_REQUEST:
      return {
        ...state,
        isNotFound: false,
        isFetching: true,
      };

    case EActionTypes.CHECK_ESTIMATION_EXISTS_ERROR:
      return {
        ...state,
        isFetching: false,
        isNotFound: true,
      };

    case EActionTypes.RESET_CHECK_ESTIMATION_EXISTS:
      return {
        ...state,
        isFetching: false,
        isNotFound: false,
      };

    case EActionTypes.SET_ESTIMATION_READY:
      return {
        ...state,
        isFetching: false,
        isNotFound: false,
        estimationId: action.payload.estimationId,
        offer: action.payload.offer,
      };

    default:
      return state;
  }
};
